export enum termsAndConditionConstants{
    termsAndConditionRequest = 'TERM_AND_CONDITION_REQUEST',
    termsAndConditionSuccess = 'TERM_AND_CONDITION_SUCCESS',
    termsAndConditionFailure = 'TERM_AND_CONDITION_FAILURE',

    termsofServiceRequest = 'TERMS_OF_SERVICE_REQUEST',
    termsofServiceSuccess = 'TERMS_OF_SERVICE_SUCCESS',
    termsofServiceFailure = 'TERMS_OF_SERVICE_FAILURE',

    privacyPolicyRequest = 'PRIVACY_POLICY_REQUEST',
    privacyPolicySuccess = 'PRIVACY_POLICY_SUCCESS',
    privacyPolicyFailure = 'PRIVACY_POLICY_FAILURE',

}